import PasswordReset from "./pages/PasswordReset";
import { useState } from "react";
import { BrowserRouter, Navigate, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import "@/workspace.css";
import "@/workspace-experience.css";
import { useLang } from "@/i18n";
import Landing from "@/pages/Landing";
import NewNoorinHomePreview from "@/pages/NewNoorinHomePreview";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Workspace, { WorkspaceIndex, WorkspaceLegacyRedirect, WorkspaceScreen } from "@/pages/Workspace";
import Dashboard from "@/components/workspace/Dashboard";
import Chat from "@/components/workspace/Chat";
import Intake from "@/components/workspace/Intake";
import Business from "@/components/workspace/Business";
import Reports from "@/components/workspace/Reports";
import Files from "@/components/workspace/Files";
import Strategy from "@/components/workspace/Strategy";
import Services from "@/components/workspace/Services";
import Subscription from "@/components/workspace/Subscription";
import Tasks from "@/components/workspace/Tasks";
import Strategist from "@/components/workspace/Strategist";
import AdvisorPricingQuotes from "@/pages/AdvisorPricingQuotes";
import { LEGACY_REDIRECTS, WORKSPACE_BASE, WORKSPACE_SECTIONS } from "@/workspace/sections";

const WORKSPACE_SCREENS = {
  home: Dashboard,
  intake: Intake,
  business: Business,
  reports: Reports,
  tasks: Tasks,
  services: Services,
  "growth-club": Subscription,
  strategist: Strategist,
};

function AppRouter({ lang, t, change, setUser }) {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback t={t} onAuth={setUser} />;
  return (
    <Routes>
      <Route path="/forgot-password" element={<PasswordReset lang={lang} />} />
      <Route path="/reset-password" element={<PasswordReset lang={lang} />} />
      <Route path="/3d-preview" element={<NewNoorinHomePreview />} />
      <Route path="/" element={<NewNoorinHomePreview />} />
      <Route path="/login" element={<Auth mode="login" lang={lang} t={t} change={change} onAuth={setUser} />} />
      <Route path="/register" element={<Auth mode="register" lang={lang} t={t} change={change} onAuth={setUser} />} />
      <Route path="/advisor/pricing-quotes" element={<AdvisorPricingQuotes lang={lang} />} />
      <Route path="/workspace" element={<Workspace lang={lang} t={t} change={change} setUser={setUser} />}>
        <Route index element={<WorkspaceIndex />} />
        {WORKSPACE_SECTIONS.map((section) => (
          <Route key={section.id} path={section.path} element={<WorkspaceScreen Screen={WORKSPACE_SCREENS[section.path]} />} />
        ))}
        <Route path="files" element={<WorkspaceScreen Screen={Files} />} />
        {LEGACY_REDIRECTS.map(({ from, to }) => (
          <Route key={from} path={from} element={<WorkspaceLegacyRedirect to={to} />} />
        ))}
        <Route path="*" element={<Navigate to={`${WORKSPACE_BASE}/home`} replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  const { lang, t, change } = useLang();
  const [, setUser] = useState(null);
  return (
    <div className={lang === "fa" ? "app rtl" : "app"} dir={lang === "fa" ? "rtl" : "ltr"}>
      <BrowserRouter>
        <AppRouter lang={lang} t={t} change={change} setUser={setUser} />
      </BrowserRouter>
      <Toaster position={lang === "fa" ? "bottom-left" : "bottom-right"} dir={lang === "fa" ? "rtl" : "ltr"} toastOptions={{ style: { fontFamily: lang === "fa" ? "Vazirmatn, sans-serif" : "Inter, sans-serif", borderRadius: 3 } }} />
    </div>
  );
}
